import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import Loader from "../../../Common/Loader/loader";
import MUITable from "../../../Common/MUITable";
import { AllLoadingEquipment, LoadingEquipmentInnerCertificationReport } from "../../../Apis/loadingEquipmentApi";
import { Form, useLocation, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useFilterStore } from "../../AssetVehicle/store/useFilterStore";
import isGHMC, { formatDateTimeWithoutSec,formattedDateTypeTwo, getCurrentDateTime } from "../../../Common/helper/helpar";
import { Field, Formik } from "formik";
import { AllShiftMaster } from "../../../Apis/shiftMasterApi";
import { ExportLoadingEquipmentInnerCertification } from "./exportLoadingEquipmentInnerCertification";
 
const LoadingEquipmentInnercertification = ({ t }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { fetchFilterOwnerTypes, ownerTypes } = useFilterStore()
  const { startDate, endDate, ownerTypeId, zoneId, circleId, shiftId, vehicleTypeId } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [innerReportStartDate, setInnerReportStartDate] = useState(startDate);
  const [innerReportEndDate, setInnerReportEndDate] = useState(endDate);
  const [innerOwnerTypeId, setInnerOwnerTypeId] = useState(ownerTypeId);
  const [loadingEquipments, setLoadingEquipments] = useState([]);
  const [shiftType, setShiftType] = useState([]);
  const [selectedShift, setSelectedShift] = useState(shiftId);
  const [selectedLoadingEquipmentId, setSelectedLoadingEquipmentId] = useState();
  const isProd = isGHMC();
 
  useEffect(() => {
    fetchFilterOwnerTypes();
    fetchShiftData();
    fetchLoadingEquipments();
    fetchLoadingEquipmentCertificationInnerReport();
  }, []);
  const fetchShiftData = async () => {
    try {
      const shiftData = await AllShiftMaster();
      setShiftType(shiftData);
    } catch (error) {
      console.error("Error fetching shift data:", error);
    }
  };
 
  const fetchLoadingEquipmentCertificationInnerReport = async () => {
    try {
      setIsLoading(true);
      const data = await LoadingEquipmentInnerCertificationReport(
        startDate, endDate, ownerTypeId, shiftId, "", zoneId, circleId, vehicleTypeId
      );
      setReportData(addTotalRow(data));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };
 
  const fetchLoadingEquipments = async () => {
    try {
      const loadingEquipmentsData = await AllLoadingEquipment();
      setLoadingEquipments(loadingEquipmentsData);
    } catch (error) {
      console.error("Error fetching loading equipments:", error);
    }
  };
 
  // Convert HH:mm:ss or mm:ss to total seconds
  const timeToSeconds = (time) => {
    if (!time) return 0; // Handle empty values
    const parts = time.split(":").map(Number);
    if (parts.length === 3) {
      return parts[0] * 3600 + parts[1] * 60 + parts[2]; // HH:mm:ss
    } else if (parts.length === 2) {
      return parts[0] * 60 + parts[1]; // mm:ss
    }
    return 0;
  };
 
  // Convert total seconds back to HH:mm:ss format
  const secondsToTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hrs.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };
 
 
  // Function to calculate totals (including time-based fields)
  const calculateTotals = (data) => {
    return data.reduce(
      (totals, row) => {
        totals.totalShiftHours += timeToSeconds(row.totalShiftHours);
        totals.certifiedWorkedHours += timeToSeconds(row.certifiedWorkedHours);
        totals.certifiedIntransitHours += timeToSeconds(row.certifiedIntransitHours);
        totals.certifiedTotalHours += timeToSeconds(row.certifiedTotalHours);
        totals.deductBreakdownHours += timeToSeconds(row.deductBreakdownHours);
        totals.deductLateReportHours += timeToSeconds(row.deductLateReportHours);
        totals.deductEarlyLeaveHours += timeToSeconds(row.deductEarlyLeaveHours);
        totals.totalDeductionHoursPQR += timeToSeconds(row.totalDeductionHoursPQR);
        return totals;
      },
      {
        totalShiftHours: 0,
        certifiedWorkedHours: 0,
        certifiedIntransitHours: 0,
        certifiedTotalHours: 0,
        deductBreakdownHours: 0,
        deductLateReportHours: 0,
        deductEarlyLeaveHours: 0,
        totalDeductionHoursPQR: 0,
      }
    );
  };
 
  // Add a total row with properly formatted time values
  const addTotalRow = (data) => {
    if (!data.length) return data;
 
    const totals = calculateTotals(data);
 
    return [
      ...data,
      {
        zoneName: "",
        circleName: "",
        shift: "",
        loadingEquipmentNumber: "",
        ownerType: "",
        vehicleTypeName: "",
        startShiftDate: "",
        firstGVPStartTime: "",
        lastGVPEndTime: "",
        endShiftDateTime: "Total",
        totalShiftHours: secondsToTime(totals.totalShiftHours),
        certifiedWorkedHours: secondsToTime(totals.certifiedWorkedHours),
        certifiedIntransitHours: secondsToTime(totals.certifiedIntransitHours),
        certifiedTotalHours: secondsToTime(totals.certifiedTotalHours),
        deductBreakdownHours: secondsToTime(totals.deductBreakdownHours),
        deductLateReportHours: secondsToTime(totals.deductLateReportHours),
        deductEarlyLeaveHours: secondsToTime(totals.deductEarlyLeaveHours),
        totalDeductionHoursPQR: secondsToTime(totals.totalDeductionHoursPQR),
        deployedImage: "",
        endShiftImage: "",
      },
    ];
  };
 
  const reportColumns = [
    {
      label: "Zone",
      field: "zoneName",
      
      render: (row) =>row.zoneName||""
    },
    {
      label: "Circle",
      field: "circleName",
      render: (row) =>row.circleName||""
    },
    {
      label: "Shift",
      field: "shift",
       render: (row) =>row.shift||""
    },
    {
      label: "Loading Equipment Number",
      field: "loadingEquipmentNumber",
     render: (row) =>row.loadingEquipmentNumber||""
    },
    {
      label: "Vehicle Type",
      field: "vehicleTypeName",
     render: (row) =>row.vehicleTypeName||""
    },
    {
      label: "Owner Type",
      field: "ownerType",
      render: (row) =>row.ownerType||""
    },
    {
      label: "Vehicle Capacity",
      field: "vehicleCapacityName",
       render: (row) =>row.vehicleCapacityName||""
    },
    {
      label: "Start Shift Date & Time",
      field: "startShiftDate",
       render: (row) =>row.startShiftDate||""
    },
    {
      label: "First GVP Start Time",
      field: "firstGVPStartTime",
       render: (row) =>row.firstGVPStartTime||""
    },
    {
      label: "Last GVP End Time",
      field: "lastGVPEndTime",
       render: (row) =>row.lastGVPEndTime||""
    },
    {
      label: "End Shift Date & Time",
      field: "endShiftDateTime",

    },
    {
      label: "Total Shift Hours",
      field: "totalShiftHours",
      render: (row) => row.totalShiftHours == null || row.totalShiftHours == undefined ? "N/A" : row.totalShiftHours
    },
    {
      label: "Certified Worked Hrs.",
      field: "certifiedWorkedHours",
      render: (row) => row.certifiedWorkedHours == null || row.certifiedWorkedHours == undefined ? "N/A" : row.certifiedWorkedHours
    },
    {
      label: "Certified Intransit /Idle Hrs.",
      field: "certifiedIntransitHours",
      render: (row) => row.certifiedIntransitHours == null || row.certifiedIntransitHours == undefined ? "N/A" : row.certifiedIntransitHours
    },
    {
      label: "Certified Total Hrs.",
      field: "certifiedTotalHours",
      render: (row) => row.certifiedTotalHours == null || row.certifiedTotalHours == undefined ? "N/A" : row.certifiedTotalHours
    },
    {
      label: "Deduct BreakDown Hrs.",
      field: "deductBreakdownHours",
      render: (row) => row.deductBreakdownHours == null || row.deductBreakdownHours == undefined ? "N/A" : row.deductBreakdownHours
    },
    {
      label: "Deduct Late Reporting",
      field: "deductLateReportHours",
      render: (row) => row.deductLateReportHours == null || row.deductLateReportHours == undefined ? "N/A" : row.deductLateReportHours
    },
    {
      label: "Deduct Early Leaving",
      field: "deductEarlyLeaveHours",
      render: (row) => row.deductEarlyLeaveHours == null || row.deductEarlyLeaveHours == undefined ? "N/A" : row.deductEarlyLeaveHours
    },
    {
      label: "Deduct Total Hrs.",
      field: "deductTotalHours",
      render: (row) => row.totalDeductionHoursPQR == null || row.totalDeductionHoursPQR == undefined ? "N/A" : row.totalDeductionHoursPQR
    },
    {
      label: "Deployed Image",
      field: "deployedImage",
      render: (row) => (
        row.deployedImage ? (
          <img
            style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: "10px" }}
            src={row.deployedImage}
            onClick={() => handleImageClick(row.deployedImage)}
            alt="Deployed Image"
          />
        ) : " "
      ),
    },
    {
      label: "End Shift Image",
      field: "endShiftImage",
      render: (row) => (
        row.endShiftImage ? (
          <img
            style={{ width: "100px", height: "50px", objectFit: "cover", borderRadius: "10px" }}
            src={row.endShiftImage}
            onClick={() => handleImageClick(row.endShiftImage)}
            alt="End Shift Image"
          />
        ) : " "
      ),
    },
  ];
 
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };
 
  const handleClose = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };
 
  const filterHandler = async() => {
    try {
      setIsLoading(true);
      const data = await LoadingEquipmentInnerCertificationReport(
        innerReportStartDate, innerReportEndDate, innerOwnerTypeId, selectedLoadingEquipmentId, selectedShift, zoneId, circleId, vehicleTypeId
      );
      setReportData(addTotalRow(data));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  }
  const filterResetHandler = async () => {
    setInnerReportStartDate(getCurrentDateTime());
    setInnerReportEndDate(getCurrentDateTime());
    setInnerOwnerTypeId("");
    setSelectedLoadingEquipmentId("");
    setSelectedShift("")
    try {
      setIsLoading(true);
      const data = await LoadingEquipmentInnerCertificationReport(
        getCurrentDateTime(), getCurrentDateTime(), "", "", "", zoneId, circleId, vehicleTypeId
      );
      setReportData(addTotalRow(data));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  }
 
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div style={{ width: "100%" }}>
          <div className="content">
            <div className="page-content">
              <div className="d-flex align-items-center justify-content-between my-2">
                <h4 className="text-start mb-3">{t("Loading Equipment Certification")}</h4>
                <div className="d-flex gap-2">
                  <button className="btn btn-secondary m-0" onClick={() => navigate(-1)}>Back</button>
                  <ExportLoadingEquipmentInnerCertification data={location.state} row={reportData}  />
                </div>
              </div>
              <div className="top-header">
                <span>{`Loading Equipment Certification Summary as on ${formattedDateTypeTwo(startDate)} To ${formattedDateTypeTwo(endDate)}`}</span>
              </div>
              <div className="card">
                <div className="card-body p-3">
                  <div className="row d-flex align-items-end g-2">
                    <div className="col-md-2">
                      <div className="form-group">
                        <label className="form-label w-100 text-left">
                          From Date
                        </label>
                        <input
                          type="datetime-local"
                          id="FromDateTime"
                          value={innerReportStartDate}
                          name="FromDateTime"
                          className="form-control"
                          max={innerReportEndDate}
                          onChange={(e) => setInnerReportStartDate(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label className="form-label w-100 text-left">
                          To Date
                        </label>
                        <input
                          type="datetime-local"
                          id="ToDateTime"
                          name="ToDateTime"
                          value={innerReportEndDate}
                          className="form-control"
                          min={innerReportStartDate}
                          max={getCurrentDateTime()}
                          onChange={(e) => setInnerReportEndDate(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label className="form-label w-100 text-left">Owner Type</label>
                        <select
                          name="OwnerTypeId"
                          className="form-select"
                          value={innerOwnerTypeId}
                          onChange={(e) => setInnerOwnerTypeId(e.target.value)}
                        >
                          <option value="">Select</option>
                          {ownerTypes.map((type) => (
                            <option key={type.ownerTypeId} value={type.ownerTypeId}>
                              {type.ownerTypeName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label className="form-label w-100 text-left">Loading Equipment No.</label>
                        <select
                          className="form-select"
                          name="Loading Equipment No"
                          id="Loading Equipment No"
                          value={selectedLoadingEquipmentId} // You can set a selected shift if needed
                          onChange={(e) => setSelectedLoadingEquipmentId(e.target.value)} // Handle selection if needed
                        >
                          <option value="">Select</option>
                          {loadingEquipments
                            .filter((le) => le.isActive)
                            .map((le) => (
                              <option key={le.loadingEquipmentId} value={le.loadingEquipmentId}>
                                {le.loadingEquipmentNumber}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group">
                        <label className="form-label w-100 text-left">Shift</label>
                        <select
                          className="form-select"
                          name="shiftId"
                          id="shift"
                          value={selectedShift} // You can set a selected shift if needed
                          onChange={(e) => setSelectedShift(e.target.value)} // Handle selection if needed
                        >
                          <option value="">Select</option>
                          {shiftType
                            .filter((shift) => shift.isActive)
                            .map((shift) => (
                              <option key={shift.shiftId} value={shift.shiftId}>
                                {shift.shiftName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="form-group d-flex gap-2 align-items-end">
                        <button
                          type="button"
                          className={`btn  ${isProd ? "report-search-ghmc " : "report-search-swm"}`}
                          onClick={filterHandler}
                        >
                          Search
                        </button>
                        <button
                          type="reset"
                          onClick={filterResetHandler}
                          className={`btn ${isProd ? "report-search-ghmc " : "report-search-swm"}`}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                  <MUITable hasTotalRow needSRNumber columns={reportColumns} rows={reportData} tableHeight={500} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
 
      <Modal show={showImageModal} onHide={handleClose} centered>
        <Modal.Header closeButton><Modal.Title>Image Full Preview</Modal.Title></Modal.Header>
        <Modal.Body>
          <img src={selectedImage} alt="Full vehicle" style={{ width: "100%", height: "400px", borderRadius: "5px", objectFit: "contain" }} />
        </Modal.Body>
      </Modal>
    </>
  );
};
 
export default withTranslation()(LoadingEquipmentInnercertification);